/*
 * @Author: 刘小博
 * @Date: 2023-02-17 15:52:14
 * @LastEditTime: 2023-02-17 15:53:46
 * @LastEditors: 刘小博
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\cost-control\finance-manage\modules\cashierManageRouter.js
 * 出纳管理
 */
const cashierManageRouter = [
    // 费控系统 财务管理 财务出纳管理
    {
      path: '/costControlSystem/financial-cashier/management/index',
      name: 'costControlSystemFinancialCashierManagement',
      component: () =>
        import(
          /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
          '@/views/costControlSystem/financialCashier/management/index.vue'
        ),
      meta: {
        SecondaryMenu: '财务管理', //二级菜单
        title: '财务出纳管理',
      },
    },
    // 费控系统  财务管理 财务出纳管理 详情
    {
      path: '/costControlSystem/financial-cashier/management/detail/:cost_cashier_id/:type',
      name: 'costControlSystemFinancialCashierManagementDetail',
      component: () =>
        import(
          /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
          '@/views/costControlSystem/financialCashier/management/detail.vue'
        ),
      meta: {
        SecondaryMenu: '财务管理', //二级菜单
        title: '财务出纳管理详情',
        breadcrumb: [
          {
            title: '财务出纳管理',
            name: 'costControlSystemFinancialCashierManagement',
          },
        ],
      },
    },
]
export default cashierManageRouter
